import { useState } from 'react';
import { api } from '../api/client';
import { useUser } from '../auth/session';
import { Field, FormError, useSubmit } from '../components/Field';
import { AiPermissionsPanel } from './account/AiPermissionsPanel';
import { CloudLimitPanel } from './account/CloudLimitPanel';
import { ApiTokensPanel } from './account/ApiTokensPanel';
import { ConnectedAppsPanel } from './account/ConnectedAppsPanel';
import { DeleteAccountPanel } from './account/DeleteAccountPanel';
import { DevicesPanel } from './account/DevicesPanel';
import { NotificationsPanel } from './account/NotificationsPanel';
import { ModelSourcesPanel } from './account/ModelSourcesPanel';

function ChangePasswordForm() {
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNew] = useState('');
  const [done, setDone] = useState(false);
  const form = useSubmit(() => api.changePassword({ currentPassword, newPassword }), () => {
    setDone(true);
    setCurrent('');
    setNew('');
  });
  return (
    <form onSubmit={(e) => { setDone(false); form.submit(e); }} noValidate className="panel">
      <h2>Change password</h2>
      <Field label="Current password" name="currentPassword" type="password" value={currentPassword} onChange={setCurrent} autoComplete="current-password" error={form.fieldErrors.currentPassword} />
      <Field label="New password" name="newPassword" type="password" value={newPassword} onChange={setNew} autoComplete="new-password" error={form.fieldErrors.newPassword} hint="At least 10 characters. Your other devices will be signed out." />
      <FormError message={form.formError} />
      {done && <p role="status" className="success">Password changed. Other devices were signed out.</p>}
      <button type="submit" disabled={form.pending}>Change password</button>
    </form>
  );
}

export function AccountPage() {
  const user = useUser();
  return (
    <section aria-labelledby="account-title">
      <h1 id="account-title">Account</h1>
      <p className="muted">Signed in as <strong>{user.displayName}</strong> ({user.username}) · {user.role}</p>
      <DevicesPanel />
      <NotificationsPanel />
      <ChangePasswordForm />
      <ModelSourcesPanel />
      <CloudLimitPanel />
      <ConnectedAppsPanel />
      <ApiTokensPanel />
      <AiPermissionsPanel />
      <DeleteAccountPanel />
    </section>
  );
}
